var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"padding-top":"80px"}},[_c('vue-navigation-bar',{staticClass:"blue darken-4 aki",attrs:{"options":_vm.navbarOptions},on:{"vnb-item-clicked":_vm.vnbItemClicked}}),_c('v-row',[_c('v-col',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }